{
    "NAME": "Aperçu de l'administrationLangue",
    "AdminOverview_Intro": "Choisissez un CME, un serveur de téléphonie et une partition pour afficher les zones d'administration disponibles et les décomptes actuels.",
    "AdminOverview_Search_Helper": "La recherche s'applique aux résultats affichés ici et se poursuit sur la page d'administration sélectionnée.",
    "AdminOverview_State_Loading": "Chargement",
    "AdminOverview_State_Error": "Impossible de charger le dernier décompte",
    "AdminOverview_State_NoTelephonyServer": "Aucun serveur de téléphonie dans le périmètre",
    "AdminOverview_State_SelectTelephonyServer": "Sélectionnez un serveur de téléphonie pour charger ce décompte",
    "AdminOverview_State_SelectTelephonyServerAndPartition": "Sélectionnez un serveur de téléphonie et une partition pour charger ce nombre.",
    "AdminOverview_State_SelectPartition": "Sélectionnez une partition spécifique pour afficher ce nombre.",
    "AdminOverview_State_MessagesLegacy": "page d'administration héritée",
    "AdminOverview_State_DatabaseLegacy": "page d'administration héritée",
    "AdminOverview_Tile_Cme_Title": "CME",
    "AdminOverview_Tile_Cme_Subtitle": "structure de service",
    "AdminOverview_Tile_Cme_Summary": "Formations médicales continues pour enfants",
    "AdminOverview_Tile_Cme_Aria": "Formations médicales continues ouvertes",
    "AdminOverview_Tile_Telsys_Title": "Serveurs de téléphonie",
    "AdminOverview_Tile_Telsys_Subtitle": "Plateforme",
    "AdminOverview_Tile_Telsys_Summary": "Nombre total de serveurs",
    "AdminOverview_Tile_Telsys_Aria": "Serveurs de téléphonie ouverts",
    "AdminOverview_Tile_Partitions_Title": "Cloisons",
    "AdminOverview_Tile_Partitions_Subtitle": "Portée de la partition",
    "AdminOverview_Tile_Partitions_Summary": "Cloisons",
    "AdminOverview_Tile_Partitions_Aria": "Cloisons ouvertes",
    "AdminOverview_Tile_Users_Title": "Utilisateurs",
    "AdminOverview_Tile_Users_Subtitle": "Accès à l'application",
    "AdminOverview_Tile_Users_Summary": "Utilisateurs",
    "AdminOverview_Tile_Users_Aria": "Utilisateurs ouverts",
    "AdminOverview_Tile_Devices_Title": "Appareils",
    "AdminOverview_Tile_Devices_Subtitle": "Inventaire des points de terminaison",
    "AdminOverview_Tile_Devices_Summary": "Appareils",
    "AdminOverview_Tile_Devices_Aria": "Appareils ouverts",
    "AdminOverview_Tile_Devices_Extension": "Extension",
    "AdminOverview_Tile_Devices_ExtensionTrunking": "Extension (Tronçonneuse)",
    "AdminOverview_Tile_Devices_ExtensionHospitality": "Extension (Hôtellerie)",
    "AdminOverview_Tile_Devices_Groups": "Groupes",
    "AdminOverview_Tile_Devices_AutoAttendant": "Répondant automatique",
    "AdminOverview_Tile_Agents_Title": "Agents",
    "AdminOverview_Tile_Agents_Subtitle": "Opérations de file d'attente",
    "AdminOverview_Tile_Agents_Summary": "Agents",
    "AdminOverview_Tile_Agents_Aria": "Agents ouverts",
    "AdminOverview_Tile_Directory_Title": "Annuaire",
    "AdminOverview_Tile_Directory_Subtitle": "Fiches de contact",
    "AdminOverview_Tile_Directory_Summary": "Annuaires",
    "AdminOverview_Tile_Directory_Aria": "Répertoire ouvert",
    "AdminOverview_Tile_Codes_Title": "Codes",
    "AdminOverview_Tile_Codes_Subtitle": "Gestion du code",
    "AdminOverview_Tile_Codes_Summary": "Codes",
    "AdminOverview_Tile_Codes_Aria": "Codes ouverts",
    "AdminOverview_Tile_Recording_Title": "Enregistrement",
    "AdminOverview_Tile_Recording_Subtitle": "Intégrations",
    "AdminOverview_Tile_Recording_Summary": "Enregistrements",
    "AdminOverview_Tile_Recording_Aria": "Enregistrement ouvert",
    "AdminOverview_Tile_Messages_Title": "Messages",
    "AdminOverview_Tile_Messages_Subtitle": "Outils hérités",
    "AdminOverview_Tile_Messages_Aria": "Ouvrir les messages",
    "AdminOverview_Tile_Database_Title": "Base de données",
    "AdminOverview_Tile_Database_Subtitle": "Outils hérités",
    "AdminOverview_Tile_Database_Aria": "Base de données ouverte"
}